import { useEffect } from "react";
import "../styles/Contents.css";

export default function ContactUs() {
  useEffect(() => {
    const elements = document.querySelectorAll(
      ".reveal, .reveal-left, .reveal-right"
    );

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add("active");
          } else {
            entry.target.classList.remove("active");
          }
        });
      },
      { threshold: 0.15 }
    );

    elements.forEach((el) => observer.observe(el));
    return () => observer.disconnect();
  }, []);

  return (
    <div className="page">
      {/* HERO */}
      <section className="about-hero reveal">
        <h1>Contact ACCESS</h1>
        <p>
          We’re here to guide you. Reach out for admissions, courses, or any
          academic support.
        </p>
      </section>

      {/* CONTACT INFO */}
      <section className="about-sectio">
        <div className="about-text reveal-left">
          <h2>Get in Touch</h2>

          <p>
            ACCESS Coaching Institute welcomes students and parents to connect
            with us for detailed counseling, course information, hostel
            facilities, and admissions guidance.
          </p>

          <p>
            📞 <strong>Phone:</strong><br />
            +91 9964 585 585<br />
            +91 9964 585 567
          </p>

          <p>
            📍 <strong>Address:</strong><br />
            163/8, Bidarahosahalli Road,<br />
            Next to Aryabhata International School,<br />
            Bidarahosahalli, Maddur Taluk,<br />
            Mandya District, Karnataka – 571422
          </p>

          <p>
            🕘 <strong>Office Hours:</strong><br />
            Monday – Saturday: 9:00 AM – 7:00 PM
          </p>

          <p>
            📧 <strong>Email:</strong><br />
            info@accesscoaching.in
          </p>
        </div>

        {/* MAP */}
        <div className="about-image reveal-right">
          <iframe
            title="ACCESS Coaching Institute Location"
            src="https://www.google.com/maps?q=163/8%20Bidarahosahalli%20Road%20Maddur%20Mandya%20Karnataka%20571422&output=embed"
            width="100%"
            height="380"
            style={{
              border: 0,
              borderRadius: "20px",
              boxShadow: "0 20px 40px rgba(0,0,0,0.12)",
            }}
            allowFullScreen=""
            loading="lazy"
            referrerPolicy="no-referrer-when-downgrade"
          ></iframe>
        </div>
      </section>

      {/* FOOTER NOTE */}
      <section className="about-footer reveal">
        <p>
          Visit our campus to experience a disciplined academic environment,
          expert faculty guidance, and a student-focused learning culture.
          Your success begins with the right guidance — and we are here to
          provide it.
        </p>
      </section>
    </div>
  );
}
